import React from 'react';

/**
 * 考试信息表格组件
 * 显示考试的基本信息，如考试类型、时间、合格标准等
 * @param {Object} props - 组件属性
 * @param {Object} props.examInfo - 考试信息对象
 * @returns {JSX.Element} 考试信息表格组件
 */
const ExamInfoTable = ({ examInfo }) => {
  // 如果没有提供考试信息，使用默认值
  const info = examInfo || {
    examType: '未指定考试类型',
    duration: '未指定',
    passingScore: '未指定',
    examRule: '未指定'
  };

  return (
    <div className="overflow-hidden rounded-xl bg-gray-50 border border-gray-100 shadow-sm">
      <div className="flex border-b border-gray-200">
        <div className="p-3.5 w-[95px] bg-gray-100 text-sm font-medium text-gray-700 flex items-center">考试类型</div>
        <div className="p-3.5 flex-1 bg-white text-sm text-gray-700 flex items-center">{info.examType}</div>
      </div>
      <div className="flex border-b border-gray-200">
        <div className="p-3.5 w-[95px] bg-gray-100 text-sm font-medium text-gray-700 flex items-center">考试时间</div>
        <div className="p-3.5 flex-1 bg-white text-sm text-gray-700 flex items-center">
          {typeof info.duration === 'number' ? `${info.duration}分钟` : info.duration}
        </div>
      </div>
      <div className="flex border-b border-gray-200">
        <div className="p-3.5 w-[95px] bg-gray-100 text-sm font-medium text-gray-700 flex items-center">合格标准</div>
        <div className="p-3.5 flex-1 bg-white text-sm text-gray-700 flex items-center">
          {typeof info.passingScore === 'number' ? `${info.passingScore}分` : info.passingScore}
        </div>
      </div>
      <div className="flex">
        <div className="p-3.5 w-[95px] bg-gray-100 text-sm font-medium text-gray-700 flex items-center">出题规则</div>
        <div className="p-3.5 flex-1 bg-white text-sm text-gray-700 flex items-center">{info.examRule}</div>
      </div>
    </div>
  );
};

export default ExamInfoTable; 